import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=dcb1e7da"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\Presentation\\Vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb1e7da')) {
      api.createRecord('dcb1e7da', component.options)
    } else {
      api.reload('dcb1e7da', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=dcb1e7da", function () {
      api.rerender('dcb1e7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/asos/Index.vue"
export default component.exports